import React from "react";
import { Check, CheckCircle, Star, Award, MapPin, Users } from "lucide-react";

const TrustIndicatorsSection = () => {
  return (
    <section className="py-12 md:py-16 px-4 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto max-w-6xl">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-12">
          <div className="inline-flex items-center space-x-2 bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-medium mb-4">
            <Check className="h-4 w-4" />
            <span>Verified Authentic Service</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3">
            Why Devotees Trust Us
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Genuine hereditary priest service with proven authenticity and
            thousands of satisfied devotees
          </p>
        </div>

        {/* Main Trust Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-8 md:mb-12">
          {/* Hereditary Lineage */}
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-orange-100 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center">
                <Award className="h-6 w-6 text-white" />
              </div>
              <div className="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs font-medium">
                VERIFIED
              </div>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">
              54th Generation Lineage
            </h3>
            <p className="text-gray-600 mb-4">
              Hereditary Shreepujak family serving since 1470 AD - over 1000
              years of authentic tradition
            </p>
            <div className="flex items-center text-sm text-green-600">
              <CheckCircle className="h-4 w-4 mr-2" />
              <span>Family heritage documented</span>
            </div>
          </div>

          {/* Location Authenticity */}
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-orange-100 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center">
                <MapPin className="h-6 w-6 text-white" />
              </div>
              <div className="bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-xs font-medium">
                LOCAL
              </div>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">
              Born in Kolhapur
            </h3>
            <p className="text-gray-600 mb-4">
              Local resident with deep knowledge of authentic Mahalaxmi Ambabai
              traditions and customs
            </p>
            <div className="flex items-center text-sm text-blue-600">
              <MapPin className="h-4 w-4 mr-2" />
              <span>Visit us in Kolhapur anytime</span>
            </div>
          </div>

          {/* Experience */}
          <div className="bg-white rounded-2xl p-6 shadow-lg border border-orange-100 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-teal-500 rounded-full flex items-center justify-center">
                <Star className="h-6 w-6 text-white" />
              </div>
              <div className="bg-yellow-100 text-yellow-700 px-2 py-1 rounded-full text-xs font-medium">
                EXPERT
              </div>
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">
              No third party involved
            </h3>
            <p className="text-gray-600 mb-4">
              we guarantee the quality, sanctity, and integrity of your
              rituals—upholding the highest traditional standards.
            </p>
            <div className="flex items-center text-sm text-green-600">
              <Star className="h-4 w-4 mr-2" />
              <span>Authentic Experience</span>
            </div>
          </div>
        </div>

        {/* What Makes Us Authentic */}
        {/* <div className="bg-gradient-to-r from-orange-50 via-white to-red-50 rounded-2xl p-6 md:p-8 border border-orange-200 mb-8 md:mb-12">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center">
            What Makes Us Authentic
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-md">
                <span className="text-2xl">📿</span>
              </div>
              <h4 className="font-semibold text-gray-800 mb-2">
                Traditional Sanskrit
              </h4>
              <p className="text-sm text-gray-600">
                Pure Vedic mantras in authentic pronunciation
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-md">
                <span className="text-2xl">🛕</span>
              </div>
              <h4 className="font-semibold text-gray-800 mb-2">
                Temple Methods
              </h4>
              <p className="text-sm text-gray-600">
                Exact same rituals as performed in main temple
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-3 shadow-md">
                <span className="text-2xl">🙏</span>
              </div>
              <h4 className="font-semibold text-gray-800 mb-2">
                Personal Service
              </h4>
              <p className="text-sm text-gray-600">
                Direct consultation with hereditary priest
              </p>
            </div>
          </div>
        </div> */}

        {/* Real Testimonials */}
        {/* <div className="mb-8 md:mb-12">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center">
            What Devotees Say
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-orange-400 to-red-400 rounded-full flex items-center justify-center text-white font-bold">
                  R
                </div>
                <div className="ml-3">
                  <div className="font-semibold text-gray-800">
                    Rajesh Patil
                  </div>
                  <div className="text-sm text-gray-600">Mumbai</div>
                </div>
                <div className="ml-auto flex text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-current" />
                  ))}
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Authentic service with real Sanskrit mantras. The video
                showed every detail of the puja. Felt truly blessed!"
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full flex items-center justify-center text-white font-bold">
                  P
                </div>
                <div className="ml-3">
                  <div className="font-semibold text-gray-800">
                    Priya Sharma
                  </div>
                  <div className="text-sm text-gray-600">Delhi</div>
                </div>
                <div className="ml-auto flex text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-current" />
                  ))}
                </div>
              </div>
              <p className="text-gray-700 italic">
                "54th generation priest means authentic tradition. No shortcuts,
                complete ceremony as promised. Highly recommended!"
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-green-400 to-blue-400 rounded-full flex items-center justify-center text-white font-bold">
                  A
                </div>
                <div className="ml-3">
                  <div className="font-semibold text-gray-800">Amit Desai</div>
                  <div className="text-sm text-gray-600">Pune</div>
                </div>
                <div className="ml-auto flex text-yellow-400">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="h-4 w-4 fill-current" />
                  ))}
                </div>
              </div>
              <p className="text-gray-700 italic">
                "Direct contact with priest, answered all questions. Traditional
                ingredients, proper timing. This is genuine service!"
              </p>
            </div>
          </div>
        </div> */}

        {/* Trust Badges */}
        {/* <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-gray-200">
          <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-6 text-center">
            Trust & Authenticity Badges
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            <div className="text-center p-4 bg-green-50 rounded-xl border border-green-200">
              <CheckCircle className="h-8 w-8 text-green-600 mx-auto mb-2" />
              <div className="font-semibold text-green-800 text-sm">
                Verified Heritage
              </div>
              <div className="text-xs text-green-600">54 Generations</div>
            </div>
            <div className="text-center p-4 bg-blue-50 rounded-xl border border-blue-200">
              <Video className="h-8 w-8 text-blue-600 mx-auto mb-2" />
              <div className="font-semibold text-blue-800 text-sm">
                Full Transparency
              </div>
              <div className="text-xs text-blue-600"> Video Proof</div>
            </div>
            <div className="text-center p-4 bg-orange-50 rounded-xl border border-orange-200">
              <Phone className="h-8 w-8 text-orange-600 mx-auto mb-2" />
              <div className="font-semibold text-orange-800 text-sm">
                Direct Contact
              </div>
              <div className="text-xs text-orange-600">Speak to Priest</div>
            </div>
            <div className="text-center p-4 bg-purple-50 rounded-xl border border-purple-200">
              <Heart className="h-8 w-8 text-purple-600 mx-auto mb-2" />
              <div className="font-semibold text-purple-800 text-sm">
                2L+ Devotees
              </div>
              <div className="text-xs text-purple-600">Satisfied Families</div>
            </div>
          </div>
        </div> */}

        {/* Call to Action */}
        {/* <div className="text-center mt-8 md:mt-12">
          <div className="bg-gradient-to-r from-orange-500 to-red-500 rounded-2xl p-6 md:p-8 text-white">
            <h3 className="text-2xl md:text-3xl font-bold mb-3">
              Experience Authentic Blessings
            </h3>
            <p className="text-lg mb-6 opacity-90">
              Join 2+ lakh families who trust our hereditary priest service
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-white text-orange-600 px-6 py-3 rounded-full font-semibold hover:bg-gray-100 transition-all transform hover:scale-105">
                📞 Speak to Priest Directly
              </button>
              <button className="border-2 border-white text-white px-6 py-3 rounded-full font-semibold hover:bg-white hover:text-orange-600 transition-all transform hover:scale-105">
                🚀 Book Puja Now
              </button>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default TrustIndicatorsSection;
